export const desktop = `@media only screen and (min-device-width : 768px) and (orientation : landscape)`

export default {
  desktop
}